import React from 'react';
import { motion } from 'framer-motion';
export const PainSection = () => {
  return <section className="py-20 sm:py-32 px-4 bg-brand-dark text-brand-light" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg sm:text-xl leading-relaxed" data-id="element-115">
          <p data-id="element-116">
            You've spent 15 years building your career. The late nights, the
            sacrifices, the constant climbing. And now, you're looking at a
            software window that seems to do in 3 seconds what takes you 3
            hours.
          </p>

          <p data-id="element-117">
            The "Old Guard" is being{' '}
            <span className="text-brand-accent font-bold" data-id="element-118">pushed out</span>.
            Middle management is being thinned. If you continue working the way
            you did in 2023, you aren't just falling behind—you are becoming{' '}
            <span className="text-brand-accent font-bold" data-id="element-119">obsolete</span>.
          </p>

          <div className="bg-brand-accent/10 border border-brand-accent/20 p-8 sm:p-10 rounded-sm mt-12" data-id="element-120">
            <p className="font-serif text-2xl sm:text-3xl font-bold text-white text-center leading-tight" data-id="element-121">
              Every day you wait to master this technology is a day you become
              more <span className="text-brand-accent" data-id="element-122">replaceable</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};